// extracted by mini-css-extract-plugin
module.exports = {"file":"restDetailsUpload_file__w9eCI","submit":"restDetailsUpload_submit__3qOBK"};